import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from '@material-ui/core/Grid';
import SectionHeadStatut from './sectionHeadStatut';
import getDateFromString from "../../utils/getDateFromString"
import ModalInfo from "./modalInfo";
import { SlArrowDown } from "react-icons/sl";
import { resetProcess } from './../../store/action/taskAction';
import { useDispatch } from 'react-redux';
import { deleteClaim } from '../../store/action/claim';
import { translateClaimStatus } from "../../utils/translateStatus";
import { translateDamageType } from "../../utils/translateDamageType";
import { hasAuthorities } from "../../utils/authoritiesUtils";
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Button, Drawer } from "@material-ui/core";
import CalendarComponent from "../../components/Calendar/CalendarComponent";
import CalendarRangeComponent from "../../components/CalendarRange/CalendarRangeComponent";
import {
  updateServiceProposal
  , getClaimServiceProposals
  , getClaimReparationMissions
  , updateReparationMission
} from "../../store/action/claimManagement.js";

import { sendMessage } from "./../../store/action/taskAction";
import Component360 from "./360.js";
import ForcageSuccessPopup from "./ForcageSuccessPopup";
import { CircularProgress } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    borderRadius: '11px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',

  },
  tableWrapper: {
    padding: "20px", width: "100%"
  },
  titer: {
    fontFamily: 'Poppins', fontSize: '13.8px', fontWeight: 600, lineHeight: '20.7px', textAlign: 'left', color: 'rgba(63, 66, 84, 1)', padding: '3px'
  },
  item: { fontFamily: 'Poppins', fontSize: '12.81px', fontWeight: 500, lineHeight: '19.22px', textAlign: 'left', color: 'rgba(181, 181, 195, 1)', padding: '3px' },
  buttonAdvanced: { cursor: 'pointer', alignItems: 'center', width: 'fit-content', borderRadius: '5.38px', border: '1px solid rgba(187, 200, 8, 1)', height: '36px', color: 'rgba(187, 200, 8, 1)', fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, lineHeight: '16.14px', marginRight: '20px', background: '#f2f2f2', },
  buttonEdit: { cursor: 'pointer', width: '65px', borderRadius: '5.38px', border: '1px solid rgba(187, 200, 8, 1)', height: '36px', color: 'rgba(255, 255, 255, 1)', fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, lineHeight: '16.14px', background: 'rgba(187, 200, 8, 1)', marginRight: '20px' },
  buttonVision: { cursor: 'pointer', width: 'fit-content', borderRadius: '5.38px', border: '1px solid rgba(187, 200, 8, 1)', height: '36px', color: 'rgba(255, 255, 255, 1)', fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, lineHeight: '16.14px', background: 'rgba(187, 200, 8, 1)' },

  dropdownMenu: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: 'white',
    border: '0.61px solid rgba(226, 217, 239, 1)',
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    width: "180px",
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    color: 'rgba(32, 18, 70, 1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
    fontWeight: 400,
    textAlign: 'left',
  },
  dropdownItemDelete: {
    width: "180px",
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 229, 229, 1)',
    },
    color: 'rgba(255, 54, 54, 1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
    fontWeight: 600,
    textAlign: 'left',
    borderTop: '1px solid rgba(226, 217, 239, 1)',
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  TextContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 15px",
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(128, 128, 143, 1)",
  },
  cardValue: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(24, 28, 50, 1)",
    textAlign: "Right",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    textAlign: "Right",
    padding: "5px",
    width: "240px",
    height: "30px",
    borderRadius: "4px",
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "rgb(255, 54, 54)",
    backgroundColor: " rgb(255, 229, 229)",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  drawerContent: {
    width: '87vw', // Set the drawer width to 70% of the viewport width
    padding: 50, // Add padding if needed
  },
  loadingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'rgb(60, 101, 86)',
  },
  loadingIndicator: {
    color: 'rgb(60, 101, 86)',
  },
}));

function InformationSinistre(props) {
  const informationSinistre = props.informationSinistre;
  const dispatch = useDispatch();
  const showAdvanced = props.showAdvanced
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [claimStatus, setClaimStatus] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedContext, setSelectedContext] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [reasonForDelay, setReasonForDelay] = useState('');
  const [startRepairDate, setStartRepairDateValue] = useState('');
  const [endRepairDate, setEndRepairDateValue] = useState('');
  const [forecastEntryDate, setForecastEntryDateValue] = useState('');
  const [localManagementType, setLocalManagementType] = useState(informationSinistre?.managementType);
  const [localStatus, setLocalStatus] = useState(informationSinistre?.status);
  useEffect(() => {
    setLocalStatus(informationSinistre?.status);
  }, [informationSinistre?.status]);
  const [localClaimStatus, setLocalClaimStatus] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const wrapperRef = useRef(null);
  const reparationDropdownRef = useRef(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [deleteClaimDialogOpen, setDeleteClaimDialogOpen] = useState(false);
  const [deleteClaimLoading, setDeleteClaimLoading] = useState(false);
  const [deleteClaimError, setDeleteClaimError] = useState(null);
  const navigate = useNavigate();

  const getGuarantees = (affectedCoverages) => {
    const guarantees = affectedCoverages.map(affected => affected.coverage?.label)
    return guarantees
  }

  const getClaimStatus = () => {
    const status = localStatus;

    switch (status) {
      case "OPEN":
        setLocalClaimStatus(0);
        break;
      case "AWAITING_INSPECTION":
      case "VEHICLE_INSPECTED":
      case "AWAITING_FINAL_REPORT":
        setLocalClaimStatus(1);
        break;
      case "CLOSED":
        setLocalClaimStatus(2);
        break;
      default:
        setLocalClaimStatus(0);
    }
  };

  const classes = useStyles();
  useEffect(() => {
    getClaimStatus();
  }, [localStatus]);

  const handleDropdownClick = () => {
    setDropdownOpen(prev => !prev);
  };

  const handleActionClick = async (context) => {
    setSelectedContext(context);
    setDropdownOpen(false);
    setIsLoading(true);
    setLocalManagementType(context);
    let newStatus;
    switch (context) {
      case 'RGA':
        newStatus = 'AWAITING_SERVICE_PROPOSAL';
        break;
      case 'CLASSIQUE':
        newStatus = 'AWAITING_SERVICE_ASSIGNMENT';
        break;
      case 'AUTOP':
        newStatus = 'AWAITING_SERVICE_PROPOSAL';
        break;
      case 'AfriqueAssistance':
        newStatus = 'AWAITING_SERVICE_PROPOSAL';
        break;
      case '-500':
        newStatus = 'AWAITING_PROVIDER_INVOICE';
        break;
      default:
        newStatus = localStatus;
    }

    if (newStatus) {
      setLocalStatus(newStatus);
    }

    try {
      await dispatch(resetProcess(informationSinistre.claimNumber, context));
      setIsLoading(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error('Error resetting process:', error);
      setIsLoading(false);
    }
  };

  const handleReparationClick = async (context) => {
    setSelectedContext(context);
    setDropdownOpen(false);
    setIsLoading(true);
    setShowModal(true, context);
    setIsLoading(false);
  };

  const handleDeleteClaimClick = () => {
    setDropdownOpen(false);
    setDeleteClaimDialogOpen(true);
  };

  const handleConfirmDeleteClaim = async () => {
    if (!informationSinistre?.claimNumber) return;
    setDeleteClaimError(null);
    setDeleteClaimLoading(true);
    try {
      await dispatch(deleteClaim(informationSinistre.claimNumber, informationSinistre._id));
      setDeleteClaimDialogOpen(false);
      navigate('/sinistres');
    } catch (err) {
      setDeleteClaimError(err.message || 'Impossible de supprimer le sinistre.');
    } finally {
      setDeleteClaimLoading(false);
    }
  };

  const handleCloseDeleteClaimDialog = () => {
    setDeleteClaimDialogOpen(false);
  };

  const handleIndiquerContext = async () => {
    try {
      // Fetch reparation missions using dispatch
      const reparationMissions = await dispatch(getClaimReparationMissions(informationSinistre.claimNumber));

      if (reparationMissions.length > 0) {
        const sortedMissions = reparationMissions.sort((a, b) => {
          const dateA = new Date(a.updatedAt || a.createdAt);
          const dateB = new Date(b.updatedAt || b.createdAt);
          return dateB - dateA;
        });
        const newestMission = sortedMissions[0];
        const updatedMission = {
          ...newestMission,
          associatedRepairer: newestMission.associatedRepairer.uid,
          estimatedReparationEntryDate: startRepairDate,
          estimatedReparationEndDate: endRepairDate,
        };

        await updateReparationMission(newestMission._id, updatedMission);

        await dispatch(sendMessage({
          businessKey: informationSinistre.claimNumber,
          messageName: 'continue',
        }));
      } else {
        console.warn('No reparation missions found.');
      }
    } catch (error) {
      console.error('Error fetching reparation missions:', error);
    }
  };

  const handleReporterContext = async () => {
    try {
      // Fetch service proposals using dispatch
      const serviceProposals = await dispatch(getClaimServiceProposals(informationSinistre.claimNumber));

      if (serviceProposals.length > 0) {
        const sortedProposals = serviceProposals.sort((a, b) => {
          const dateA = new Date(a.updatedAt || a.createdAt);
          const dateB = new Date(b.updatedAt || b.createdAt);
          return dateB - dateA;
        });
        const latestProposal = sortedProposals[0];
        const updatedProposal = {
          ...latestProposal,
          comment: reasonForDelay,
          estimatedCarDeposalDate: forecastEntryDate,
        };

        await updateServiceProposal(latestProposal._id, updatedProposal);

      } else {
        console.warn('No service proposals found.');
      }
    } catch (error) {
      console.error('Error fetching service proposals:', error);
    }
  };

  const resetForm = () => {
    setShowModal(false);
    setEndRepairDateValue('');
    setStartRepairDateValue('');
    setForecastEntryDateValue('');
    setReasonForDelay('');
  };

  const handleSubmit = async (e, context) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (context === 'Indiquer') {
        await handleIndiquerContext();
      } else if (context === 'Reporter') {
        await handleReporterContext();
      }
    } finally {
      setIsLoading(false);
    }

    resetForm();
  };

  const handleClose = () => {
    setShowModal(false);
    setEndRepairDateValue('');
    setStartRepairDateValue('');
    setForecastEntryDateValue('');
    setReasonForDelay('');
  };

  const handleDateRangeChange = (value) => {
    setDateRange(value);
    if (value && value.length === 2) {
      setStartRepairDateValue(value[0]);
      setEndRepairDateValue(value[1]);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (reparationDropdownRef.current && !reparationDropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const getDotColor = (frequency) => {
    // Return a color based on the frequency
    return frequency > 50 ? 'red' : 'green';
  };
  console.log("informationSinistre", informationSinistre);

  const daaq = informationSinistre?.daaq;

  let delegation = "N/A";
  let agency = "N/A";

  if (typeof daaq === "string") {
    const parts = daaq.split("/").filter(Boolean);

    if (parts.length >= 4) {
      delegation = parts[2] !== "*" ? parts[2] : "N/A";
      agency = parts[3] !== "*" ? parts[3] : "N/A";
    }
  }
  return (

    <>
      {isLoading && (
        <div className={classes.loadingOverlay}>
          <CircularProgress
            size={60}
            thickness={5}
            color='success'
            className={classes.loadingIndicator}
          />
        </div>
      )}
      {showAdvanced && (

        <Grid container style={{ marginBottom: '30px', marginTop: '15px', alignItems: 'center' }} justifyContent="space-between" >
          <Grid item xs={4}><SectionHeadStatut index={localClaimStatus} managementType={informationSinistre?.managementType} /></Grid>
          <Grid item>
            {hasAuthorities("VIEW_ADVANCED_ACTIONS_BUTTON") && (
              <button className={classes.buttonAdvanced}
                onClick={handleDropdownClick}>
                <span  >Actions Avancées</span>
                <span style={{ marginLeft: '25px', cursor: 'pointer', borderRadius: '5.38px', borderLeft: '1px solid rgba(187, 200, 8, 1)', padding: '9px' }} >
                  <SlArrowDown />
                </span>
                {dropdownOpen && (
                  <div className={classes.dropdownMenu} ref={wrapperRef}>
                    {hasAuthorities("DELETE_CLAIM") && (
                      <div className={classes.dropdownItemDelete} onClick={handleDeleteClaimClick}>
                        Supprimer le sinistre
                      </div>
                    )}
                  </div>
                )}
              </button>
            )}
            {hasAuthorities("VIEW_REPARATION_BUTTON") && (
              <button className={classes.buttonAdvanced}
                onClick={handleDropdownClick}>
                <span>Entrée en réparation</span>
                <span style={{ marginLeft: '50px', cursor: 'pointer', borderRadius: '5.38px', borderLeft: '1px solid rgba(187, 200, 8, 1)', padding: '9px' }} >
                  <SlArrowDown />
                </span>
                {dropdownOpen && (
                  <div className={classes.dropdownMenu} ref={reparationDropdownRef}>
                    <div className={classes.dropdownItem} onClick={() => handleReparationClick('Indiquer')}>
                      Indiquer période de réparation
                    </div>
                    <div className={classes.dropdownItem} onClick={() => handleReparationClick('Reporter')}>
                      Reporter la date d'entrée
                    </div>
                  </div>
                )}
              </button>
            )}
            {/* <button className={classes.buttonEdit}>Modifier</button> */}
            {hasAuthorities("VIEW_360_VISION_SECTION") && (
              <button className={classes.buttonVision} onClick={toggleDrawer(true)}>
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle', marginRight: '8px' }}>
                  <path d="M9.03187 10.886L8.39487 10.1151L9.03187 10.886ZM13.8774 8.17921C14.3031 7.8274 14.3631 7.19708 14.0113 6.77134C13.6595 6.3456 13.0292 6.28567 12.6034 6.63747L13.8774 8.17921ZM8.48362 10.886L9.12061 10.1151V10.1151L8.48362 10.886ZM7.35716 8.65792C6.93142 8.30612 6.3011 8.36606 5.9493 8.7918C5.5975 9.21754 5.65744 9.84786 6.08318 10.1997L7.35716 8.65792ZM4.42508 15.2345L4.84533 14.3271L4.42508 15.2345ZM3.00035 13.9395L3.87265 13.4505L3.00035 13.9395ZM16.9602 13.9395L16.0879 13.4505L16.9602 13.9395ZM15.5355 15.2345L15.1152 14.3271L15.5355 15.2345ZM15.5355 2.54549L15.1152 3.45289L15.5355 2.54549ZM16.9602 3.84051L16.0879 4.32948L16.9602 3.84051ZM4.42508 2.54549L4.84533 3.45289L4.42508 2.54549ZM3.00035 3.84051L3.87265 4.32948L3.00035 3.84051ZM9.66886 11.6569L13.8774 8.17921L12.6034 6.63747L8.39487 10.1151L9.66886 11.6569ZM9.12061 10.1151L7.35716 8.65792L6.08318 10.1997L7.84663 11.6569L9.12061 10.1151ZM8.39487 10.1151C8.51045 10.0196 8.64235 9.98232 8.75774 9.98232C8.87313 9.98232 9.00503 10.0196 9.12061 10.1151L7.84663 11.6569C8.37178 12.0908 9.14371 12.0908 9.66886 11.6569L8.39487 10.1151ZM7.86121 3.2225H12.0994V1.2225H7.86121V3.2225ZM16.3156 6.96384V10.8162H18.3156V6.96384H16.3156ZM12.0994 14.5575H7.86121V16.5575H12.0994V14.5575ZM3.64502 10.8162V6.96384H1.64502V10.8162H3.64502ZM7.86121 14.5575C6.93328 14.5575 6.29202 14.5569 5.79403 14.5199C5.3052 14.4836 5.0383 14.4165 4.84533 14.3271L4.00482 16.1419C4.50923 16.3755 5.04747 16.4699 5.64591 16.5144C6.23518 16.5581 6.9633 16.5575 7.86121 16.5575V14.5575ZM1.64502 10.8162C1.64502 11.6278 1.64408 12.3027 1.69345 12.852C1.74415 13.4161 1.85371 13.9391 2.12805 14.4285L3.87265 13.4505C3.79166 13.306 3.72355 13.0972 3.68542 12.673C3.64596 12.2339 3.64502 11.6641 3.64502 10.8162H1.64502ZM4.84533 14.3271C4.41117 14.126 4.07619 13.8136 3.87265 13.4505L2.12805 14.4285C2.54963 15.1805 3.21212 15.7748 4.00482 16.1419L4.84533 14.3271ZM16.3156 10.8162C16.3156 11.6641 16.3146 12.2339 16.2752 12.673C16.237 13.0972 16.1689 13.306 16.0879 13.4505L17.8325 14.4285C18.1069 13.9391 18.2164 13.4161 18.2671 12.852C18.3165 12.3027 18.3156 11.6278 18.3156 10.8162H16.3156ZM12.0994 16.5575C12.9973 16.5575 13.7254 16.5581 14.3147 16.5144C14.9131 16.4699 15.4513 16.3755 15.9558 16.1419L15.1152 14.3271C14.9223 14.4165 14.6554 14.4836 14.1665 14.5199C13.6686 14.5569 13.0273 14.5575 12.0994 14.5575V16.5575ZM16.0879 13.4505C15.8844 13.8136 15.5494 14.126 15.1152 14.3271L15.9558 16.1419C16.7485 15.7748 17.4109 15.1805 17.8325 14.4285L16.0879 13.4505ZM12.0994 3.2225C13.0273 3.2225 13.6686 3.22315 14.1665 3.26013C14.6554 3.29643 14.9223 3.36352 15.1152 3.45289L15.9558 1.63808C15.4513 1.40447 14.9131 1.31007 14.3147 1.26562C13.7254 1.22186 12.9973 1.2225 12.0994 1.2225V3.2225ZM18.3156 6.96384C18.3156 6.15216 18.3165 5.47727 18.2671 4.928C18.2164 4.36392 18.1069 3.84095 17.8325 3.35154L16.0879 4.32948C16.1689 4.47396 16.237 4.68285 16.2752 5.10705C16.3146 5.54606 16.3156 6.11589 16.3156 6.96384H18.3156ZM15.1152 3.45289C15.5494 3.65397 15.8844 3.96639 16.0879 4.32948L17.8325 3.35154C17.4109 2.59946 16.7485 2.00522 15.9558 1.63808L15.1152 3.45289ZM7.86121 1.2225C6.9633 1.2225 6.23518 1.22186 5.64591 1.26562C5.04747 1.31007 4.50923 1.40447 4.00482 1.63808L4.84533 3.45289C5.0383 3.36352 5.3052 3.29643 5.79403 3.26013C6.29202 3.22315 6.93328 3.2225 7.86121 3.2225V1.2225ZM3.64502 6.96384C3.64502 6.11589 3.64596 5.54606 3.68542 5.10705C3.72355 4.68285 3.79166 4.47396 3.87265 4.32948L2.12805 3.35154C1.85371 3.84095 1.74415 4.36392 1.69345 4.928C1.64408 5.47727 1.64502 6.15216 1.64502 6.96384H3.64502ZM4.00482 1.63808C3.21212 2.00522 2.54963 2.59946 2.12805 3.35154L3.87265 4.32948C4.07619 3.96639 4.41117 3.65397 4.84533 3.45289L4.00482 1.63808Z" fill="white" />
                </svg>
                Vision 360°
              </button>
            )}


          </Grid>
        </Grid>
      )}
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className={classes.drawerContent} onKeyDown={toggleDrawer(false)}>
          <Component360
            toggleDrawer={toggleDrawer}
            clientFrequency={0}
            carFrequency={0}
            getDotColor={getDotColor}
            claimNumber={informationSinistre.claimNumber}
            clientUid={informationSinistre?.involvedParties?.[0]?.partyUid}
            carUids={(informationSinistre?.involvedCars || [])
              .map(c => c?.goodUid)
              .filter(Boolean)}
          />
        </div>
      </Drawer>

      <Paper className={classes.paper}>
        <Grid container direction="row" justifyContent="star" className={classes.tableWrapper} spacing={2}  >

          <Grid item xs={2} >
            <div className={classes.titer}>N° Sinistre</div>
            <div style={{ display: 'flex', flexWrap: "wrap", alignItems: 'center' }}>
              <div className={classes.item}>{informationSinistre.claimNumber}</div>
              <div style={{
                height: '26px', borderRadius: '51px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px',
                fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 600, lineHeight: ' 16.03px', color: 'rgba(187, 200, 8, 1)',
              }}>

                Sinistres Matériels
              </div>
            </div>
          </Grid>
          <Grid item xs={2} >
            <div className={classes.titer}>Date survenance</div>
            <div className={classes.item}>{getDateFromString(informationSinistre.occurrenceDate?.toString())}</div>
          </Grid>
          <Grid item xs={2} >
            <div className={classes.titer}>Date ouverture</div>
            <div className={classes.item}> {getDateFromString(informationSinistre.openingDate?.toString())}  </div>
          </Grid>
          <Grid item xs={2} >
            <div className={classes.titer}>Date déclaration</div>
            <div className={classes.item}>{getDateFromString(informationSinistre.reportingDate?.toString())}</div>
          </Grid>
          <Grid item xs={2} >
            <div className={classes.titer}>Agence</div>
            <div className={classes.item}> {agency} </div>
          </Grid>
          <Grid item xs={2}  >
            <div className={classes.titer}>Lieux véhicule assurée</div>
            <div className={classes.item}>{informationSinistre.location || "N/A"}</div>
          </Grid>
          {/* <Grid item xs={2} >
            <div className={classes.titer}>Mode de gestion</div>
            <div className={classes.item}>{localManagementType}</div>
          </Grid> */}
          {/* <Grid item xs={2} >
            <div className={classes.titer}>Garantie Touchee</div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div className={classes.item}>{getGuarantees(informationSinistre.affectedCoverages)[0]} </div>
              {getGuarantees(informationSinistre.affectedCoverages).length > 1 ?
                <spam style={{
                  height: '26px', borderRadius: '6px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px',
                  fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 600, lineHeight: ' 16.03px', color: 'rgba(187, 200, 8, 1)',
                }}
                  onClick={() => {
                    setOpen(true);
                    setTitle("Liste des garanties");
                  }} > + {getGuarantees(informationSinistre.affectedCoverages).length}  </spam> : ""}

            </div>
          </Grid> */}
          <Grid item xs={2}  >
            <div className={classes.titer}>Délégation</div>
            <div className={classes.item}>{delegation}</div>
          </Grid>
          <Grid item xs={2}  >
            <div className={classes.titer}>Statut</div>
            <div className={classes.item}>{translateClaimStatus(localStatus)}</div>
          </Grid>

        </Grid>
      </Paper>
      <ModalInfo title={title} data={getGuarantees(informationSinistre.affectedCoverages)} open={open} close={() => setOpen(false)} />
      <Dialog
        open={deleteClaimDialogOpen}
        onClose={handleCloseDeleteClaimDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className={classes.dialogTitle} style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}>
          Supprimer le sinistre
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText style={{ fontFamily: 'Poppins', fontSize: '13px' }}>
            Êtes-vous sûr de vouloir supprimer définitivement le sinistre {informationSinistre?.claimNumber} ? Cette action est irréversible.
          </DialogContentText>
          {deleteClaimError && (
            <DialogContentText style={{ fontFamily: 'Poppins', fontSize: '13px', color: 'rgba(255, 54, 54, 1)', marginTop: 8 }}>
              {deleteClaimError}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseDeleteClaimDialog} className={classes.CancelStyle} disabled={deleteClaimLoading}>
            Annuler
          </Button>
          <Button onClick={handleConfirmDeleteClaim} className={classes.ajouterStyle} color="primary" style={{ backgroundColor: 'rgba(255, 54, 54, 1)', color: 'white' }} disabled={deleteClaimLoading}>
            {deleteClaimLoading ? 'Suppression...' : 'Supprimer'}
          </Button>
        </DialogActions>
      </Dialog>
      {showModal && (
        <Dialog
          open={showModal}
          onClose={() => setShowModal(false)}
          maxWidth={selectedContext === 'Indiquer' ? "xs" : "md"}
          fullWidth
        >
          <DialogTitle
            className={classes.dialogTitle}
            style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
          >
            {selectedContext === 'Reporter' ? 'Reporter la date d\'entrée' : 'Indiquer période de réparation'}
          </DialogTitle>

          <form onSubmit={(e) => handleSubmit(e, selectedContext)}>
            <DialogContent className={classes.dialogContent}>
              {selectedContext === 'Indiquer' ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px' }}>
                  <div className={classes.cardText} style={{ marginBottom: "10px", textAlign: "center" }}>
                    Période de réparation
                  </div>
                  <div className={classes.cardValue}>
                    <CalendarRangeComponent setDateValue={handleDateRangeChange} />
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", justifyContent: "space-between", gap: "16px" }}>
                  <div className={classes.TextContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                    <div className={classes.cardText} style={{ marginBottom: "8px", textAlign: "center" }}>
                      Date d'entrée prévisionnelle
                    </div>
                    <div className={classes.cardValue}>
                      <CalendarComponent minDate={new Date()} setDateValue={setForecastEntryDateValue} />
                    </div>
                  </div>

                  <div className={classes.TextContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                    <div className={classes.cardText} style={{ marginBottom: "8px", textAlign: "center" }}>
                      Motif du report
                    </div>
                    <div className={classes.cardValue}>
                      <textarea
                        className={classes.textarea}
                        rows={4}
                        style={{
                          background: "rgba(243, 246, 249, 1)",
                          width: "18.75rem",
                          height: "15.625rem",
                          borderRadius: "4px",
                          border: "none",
                          outline: "none",
                          padding: "40px",
                        }}
                        placeholder="Veuillez indiquer le motif du report"
                        value={reasonForDelay}
                        onChange={(e) => setReasonForDelay(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </DialogContent>

            <DialogActions style={{ backgroundColor: "rgba(243, 246, 249, 1)", padding: "16px" }}>
              <button className={classes.CancelStyle} onClick={handleClose}>
                Annuler
              </button>
              <button className={classes.ajouterStyle} type="submit">
                Valider
              </button>
            </DialogActions>
          </form>
        </Dialog>
      )}
      {showSuccessPopup && <ForcageSuccessPopup onClose={() => setShowSuccessPopup(false)} />}
    </>
  );
}

export default InformationSinistre;